<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <transition name="sidebarLogoFade">
      <div class="logobox" v-if="!collapsed">
        <img class="logoimg" src="../assets/img/logo.png" alt="">
        <span v-if="!collapsed" class="honme_title">千尚小程序后台</span>
      </div>
      <div class="logobox" v-else>
        <img class="logoimg" src="../assets/img/logo.png" alt="">
        <span v-if="!collapsed" class="honme_title">千尚小程序后台</span>
      </div>
    </transition>
    <template></template>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="'/'+menu.router" v-if="menu.children.length>0">
        <template slot="title">
          <i :class="menu.icon"></i>
          <span>{{menu.title}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.children" :index="chmenu.router" :key="chmenu.menuId">
            <i :class="chmenu.icon"></i>
            <span>{{chmenu.title}}</span>
          </el-menu-item>
        </el-menu-item-group>
    </el-submenu>
    <el-menu-item v-else :index="menu.router" :key="menu.menuId">
            <i :class="menu.icon"></i>
            <span>{{menu.title}}</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
import { ModuleTree } from '../api/system'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [],
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
      ModuleTree().then(res => {
      // console.log(res,"左侧菜单");
        if (res.rsp_code == 200) {
          let resMenu = res.body
          // resMenu.unshift({
          //       router: '/',
          //       title: '首页',
          //       icon: "el-icon-s-home",
          //       component: 'statistics',
          //       children:null
          //   })
          resMenu.map((item,index) => {
            if(item.title == '首页'){
              resMenu.unshift(resMenu.splice(index , 1)[0]);
            }
            if(item.title == '系统管理'){
              resMenu.push(resMenu.splice(index , 1)[0]);
            }
          })
            this.allmenu = resMenu
          // this.allmenu = res.body
        } else {
          this.$message.error(res.rsp_msg)
          return false
        }
      })
      .catch(err => {
        // this.$message.error('菜单加载失败，请稍后再试！')
      })

    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
  vertical-align: middle;
}
.logoimg {
  height: 30px;
  vertical-align: middle;
}
.honme_title{
  color: rgb(235, 235, 235);
  vertical-align: middle;
  padding-left: 5px;
}
.sidebarLogoFade-enter-active {
  transition: opacity 1s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue